/* eslint-disable react-refresh/only-export-components */
// Co-locating the provider and its hook is intentional; fast-refresh
// granularity is irrelevant for app-wide context.
import { createContext, useContext } from "react";
import type { ReactNode } from "react";

import { useProfiles, type UseProfilesResult } from "@/hooks/useProfiles";

const ProfileContext = createContext<UseProfilesResult | null>(null);

/**
 * Shares a single {@link useProfiles} instance across the app (sidebar switcher,
 * pages, upload flow) so the active profile and profile list stay consistent.
 */
export function ProfileProvider({ children }: { children: ReactNode }): JSX.Element {
  const value = useProfiles();
  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}

/** Access the shared profile state. Throws if used outside a {@link ProfileProvider}. */
export function useProfilesContext(): UseProfilesResult {
  const context = useContext(ProfileContext);
  if (context === null) {
    throw new Error("useProfilesContext must be used within a ProfileProvider");
  }
  return context;
}
